import React from "react";
import { Divider, Typography } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import { useTranslation } from "react-i18next";
import Utils from "~/helpers/Utils";
import { verifyAnticipationPayment } from "~/utils/checkout/anticipation";

import useStyles from "../paymentSummary/styles";

const PaymentSummaryForPackages = ({ checkoutInformation, checkoutInformationPackage, currency, singleServices, selectedPackages, offerAccepted }) => {
	const classes = useStyles();
	const { t } = useTranslation();

	if (!checkoutInformationPackage) return null;

	const packagePrice = checkoutInformationPackage?.total_value_for_services || 0;
	const packagePriceFormatted = Utils.getPostPrice(packagePrice, currency);

	// Antecipação dos serviços avulsos
	const servicesAnticipationRaw = checkoutInformation?.anticipation_payment || 0;
	const servicesAnticipationFormatted = Utils.getPostPrice(servicesAnticipationRaw, currency);

	// Valor total dos serviços avulsos
	const totalServicesSingles = singleServices.reduce((total, service) => {
		return total + (service.professional?.price || 0);
	}, 0);

	// Valor total (serviços + pacote)
	const totalValue = packagePrice + totalServicesSingles;
	const totalValueFormatted = Utils.getPostPrice(totalValue, currency);

	// Valor a pagar agora (antecipação + pacote)
	const amountToPayNow = servicesAnticipationRaw + packagePrice;
	const amountToPayNowFormatted = Utils.getPostPrice(amountToPayNow, currency);

	// Valor restante (total - antecipação - pacote já pago)
	const remainingValue = totalValue - servicesAnticipationRaw - packagePrice;
	const remainingValueFormatted = Utils.getPostPrice(remainingValue, currency);

	const hasServicesAnticipation = servicesAnticipationRaw > 0;
	const hasPackage = packagePrice > 0;
	const hasRemaining = remainingValue > 0;
	const hasAmountToPayNow = amountToPayNow > 0;
	
	// Regras específicas
	const isOnlyPackages = singleServices.length === 0 && selectedPackages.length > 0;
	const shouldShowAmountToPayNow = hasAmountToPayNow && !isOnlyPackages;
	const {hasAnticipation: hasAnticipationPayment } = verifyAnticipationPayment(checkoutInformation, checkoutInformationPackage, true);
	const hasThirdPolicy = hasAnticipationPayment && !offerAccepted && checkoutInformation?.anticipation_payment_percentage > 0;

	if (!hasAnticipationPayment || (hasThirdPolicy)) {
		return (
			<div className={classes.paymentSummary} style={{ margin: "8px 0" }}>
				<Divider style={{ margin: "8px 0" }} />
				<div className={classes.paymentTable}>
	
					<div className={classes.paymentRow}>
						<Typography className={classes.paymentLabel} style={{ fontWeight: "bold" }}>
							{t("Total")}
						</Typography>
						<Typography className={classes.paymentValue} style={{ fontWeight: "bold" }}>
							{totalValueFormatted}
						</Typography>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className={classes.paymentSummary} style={{ margin: "8px 0" }}>
			<Divider style={{ margin: "8px 0" }} />
			<div className={classes.paymentTable}>

				<div className={classes.paymentRow}>
					<Typography className={classes.paymentLabel} style={{ fontWeight: "bold" }}>
						{t("Total")}
					</Typography>
					<Typography className={classes.paymentValue} style={{ fontWeight: "bold" }}>
						{totalValueFormatted}
					</Typography>
				</div>

				{hasServicesAnticipation && (
					<div className={classes.paymentRow}>
						<Typography className={classes.paymentLabel} style={{ fontSize: "clamp(16px, 2vw, 18px)" }}>
							{t("Payment advance service")}
						</Typography>
						<Typography className={classes.paymentValue} style={{ fontWeight: "normal" }}>
							{servicesAnticipationFormatted}
						</Typography>
					</div>
				)}

				{hasPackage && (
					<div className={classes.paymentRow}>
						<Typography className={classes.paymentLabel} style={{ fontSize: "clamp(16px, 2vw, 18px)" }}>
							{isOnlyPackages ? t("Payment") : t("Package payment")}
						</Typography>
						<Typography className={classes.paymentValue} style={{ fontWeight: "normal" }}>
							{packagePriceFormatted}
						</Typography>
					</div>
				)}
				{shouldShowAmountToPayNow && (
					<div className={classes.paymentRow}>
						<Typography className={classes.paymentLabel} style={{ fontWeight: "normal", fontSize: "clamp(17px, 2vw, 20px)"}}>
						  {t("Amount to be charged now")}
						</Typography>
						<Typography className={classes.paymentValue} style={{ fontWeight: "normal"}}>
							{amountToPayNowFormatted}
						</Typography>
					</div>
				)}
				{(hasRemaining && !offerAccepted) && (
					<div className={classes.paymentRow}>
						<div style={{ display: "flex", alignItems: "center", gap: 8, width: "100%" }}>
							<InfoIcon style={{ fontSize: 18, color: "#666" }} />
							<Typography
								className={classes.paymentLabel}
								style={{ width: "100%", fontSize: "clamp(17px, 2vw, 20px)" }}>
								{t("Pay at location")}
							</Typography>
						</div>
							<Typography className={classes.paymentValue} style={{ fontWeight: "normal" }}>
								{remainingValueFormatted}
							</Typography>
					</div>
				)}
			</div>
		</div>
	);
};

export default PaymentSummaryForPackages;
